import Head from './../components/Head';
import dayjs from 'dayjs';
import Footer from '../components/Footer.vue';
import { Empty } from 'zhs-components';
import CommonTopTitle from '../components/CommonTopTitle.vue';
export default {
  created() {
    this.getNewsList();
  },

  components: {
    Head,
    Footer,
    Empty,
    CommonTopTitle
  },

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      menuName: this.$utils.getUrlParams('name'),
      newsList: [],
      newsTypeList: [],
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 12,
        newsTypeId: ''
      },
      newsName: '',
      showSearchResult: true,
      title: '',
      menuInfo: {}
    };
  },

  methods: {
    async getNewsTypeList() {
      const newsTypeList = await this.$http.getNewsClass({
        menu_id: this.menuId
      });
      console.log('分类', newsTypeList);
      this.newsTypeList = newsTypeList.content;
    },

    async getNewsList() {
      const params = {
        '_pageable.page': this.pageInfo.pageIndex - 1,
        '_pageable.size': this.pageInfo.pageLimit,
        menu_id: this.menuId,
        name: this.newsName
      };
      const res = await this.$http.getTextBookList(params);
      this.newsList = res.content;
      this.pageInfo.rows = +res.totalElements;
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getNewsList();
    },

    // 搜索
    handleSearch(newsTypeId = '') {
      this.pageInfo.pageIndex = 1;
      this.pageInfo.newsTypeId = newsTypeId;
      this.getNewsList();
      this.showSearchResult = true;
    },

    // 关键字高亮
    kewordFilter(value) {
      if (!value) return '';
      if (!this.newsName) return value;
      let reg = new RegExp(this.newsName, 'g');
      return value.replace(reg, `<span class="theme-color">${this.newsName}</span>`);
    },

    // 格式化新闻内容
    formateNews(data) {
      let result = this.$utils.getContentText(data);
      return this.kewordFilter(result);
    },

    // 点击卡片进去详情页
    showNewsDetail(item) {
      if (item.access_method === 1) {
        window.location.href = `/textBookDetail.html?id=${item.id}&menuId=${this.menuId}&name=${this.menuName}`;
      } else {
        window.open(item.link);
      }
    },

    dayjs
  }
};